import { Component } from '@angular/core';
import { AccountConfigurationService } from '../../services/account-configuration.service';
import { AccountConfigurationType } from '../../models/enums/account-configuration-type-enum';
import { ConfigurationProjectVisibility } from '../../models/enums/configuration-project-visibity-enum';

@Component({
  selector: 'account-configuration',
  templateUrl: './account-configuration.component.html',
  styleUrls: ['./account-configuration.component.scss']

})

export class AccountConfigurationComponent {
  showSecondTab = false;

  constructor(private accountConfigurationService: AccountConfigurationService) { }

  ngOnInit(): void {
    let account = localStorage.getItem("acc");

    this.accountConfigurationService.getAccountConfigurations(account).subscribe({
      next: (data) => {
        const projectVisibilityConfiguration = data.ConfigurationItems.find(element => element.Type === AccountConfigurationType.ConfigurationProjectVisibility);
        this.showSecondTab = projectVisibilityConfiguration.Value == ConfigurationProjectVisibility.PublicByGroup;
      }
    })
  }
}

